export default __webpack_public_path__ + "static/media/new-shutterstock.6a1e002e.jpg";